import { COLORS, FONTS, GRADIENTS } from './tokens';
import type { ColorTheme } from './tokens';

/** Blue CTA button style using existing GRADIENTS tokens */
export function blueBtnStyle(isDark: boolean, disabled?: boolean): React.CSSProperties {
  return {
    height: '36px',
    padding: '0 16px',
    borderRadius: '6px',
    border: 'none',
    background: isDark ? GRADIENTS.buttonDark : GRADIENTS.buttonLight,
    color: '#FFF',
    fontFamily: FONTS.heading,
    fontSize: '11px',
    letterSpacing: '0.15em',
    textTransform: 'uppercase',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    whiteSpace: 'nowrap',
  };
}

/** Standard form input style */
export function inputStyle(isDark: boolean, colors: ColorTheme): React.CSSProperties {
  return {
    height: '32px',
    padding: '0 10px',
    borderRadius: '6px',
    width: '100%',
    border: `1px solid ${colors.border}`,
    backgroundColor: isDark ? COLORS.dark.cardAlt : COLORS.light.cardAlt,
    color: colors.text,
    fontFamily: FONTS.body,
    fontSize: '13px',
    outline: 'none',
  };
}

/** Form label style */
export function labelStyle(colors: ColorTheme): React.CSSProperties {
  return {
    fontFamily: FONTS.heading,
    fontSize: '9px',
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    color: colors.textSecondary,
    marginBottom: '4px',
  };
}
